<template>
  <Toast />
  <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
    class="w-[90vw] md:w-[50vw]">
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
    </div>
    <template #footer>
      <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
    </template>
  </Dialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/user" />
      <PageTitle :title="isEdit ? 'Edit User' : 'Tambah User'" />
      <div class="w-full md:w-3/4 lg:w-1/2 bg-white dark:bg-dark-800 p-6 rounded-md shadow-md">
        <div class="grid grid-cols-12 gap-4 mb-6">
          <div class="col-span-6">
            <InputTextCustom v-model="user.name" id="name-user" label="Nama" placeholder="Masukkan nama"
              input_class="w-full" :valid="validation.name.valid" :error-message="validation.name.message" />
          </div>
          <div class="col-span-6">
            <InputTextCustom v-model="user.email" id="email-user" label="Email" placeholder="example@mail.com"
              input_class="w-full" :valid="validation.email.valid" :error-message="validation.email.message" :disable_input="isEdit" />
          </div>
        </div>
        <div class="grid grid-cols-12 gap-4 mb-6">
          <div class="col-span-6">
            <InputTextCustom v-model="user.phone" id="phone-user" label="No Telepon" placeholder="Cth: 081234567890"
              input_class="w-full" :valid="validation.phone.valid" :error-message="validation.phone.message" />
          </div>
          <div class="col-span-6">
            <label class="font-medium block text-gray-500 dark:text-gray-400">Role</label>
            <InputSelect id="user-role-id" v-model="user.role_id" :options="allRoles" optionLabel="name"
              optionValue="id" placeholder="Pilih role" />
          </div>
        </div>
        <InputTextAreaCustom v-model="user.address" id="user-address" label="Alamat Lengkap"
          placeholder="Masukkan alamat lengkap" textarea_class="mb-6" :valid="validation.address.valid"
          :error-message="validation.address.message" />
        <div class="grid grid-cols-12 gap-6 mb-10">
          <div class="col-span-12">
            <InputTextCustom v-model="user.username" id="user-username" label="Username"
              label_class="mb-1 block text-start" type="text" placeholder="Username" :valid="validation.username.valid"
              :error-message="validation.username.message" />
          </div>
          <div class="col-span-6">
            <InputTextCustom v-model="user.password" id="user-password" label="Password"
              label_class="mb-1 block text-start" type="password" placeholder="Password" :valid="validation.password.valid"
              :error-message="validation.password.message" />
          </div>
          <div class="col-span-6">
            <InputTextCustom v-model="user.confirmation" id="user-password-confirmation" label="Konfirmasi Password"
              label_class="mb-1 block text-start" type="password" placeholder="Konfirmasi Password"
              :valid="validation.confirmation.valid" :error-message="validation.confirmation.message" />
          </div>
        </div>
        <div class="flex justify-center">
          <SubmitButton id="submit" @click="submitUser" button_name="Simpan"
            button_class="rounded-md bg-color-1 px-6 py-2 text-base font-semibold text-color-4 shadow-sm hover:bg-color-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-color-3 block" />
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';
import { mapGetters, mapActions } from 'vuex';
import ViewContainer from "@/components/ViewContainer.vue";
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import { Button, Dialog, Toast } from 'primevue';

export default {
  name: "AddEditUser",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, SubmitButton, ViewContainer, InputTextCustom, InputSelect, InputTextAreaCustom, Toast, Dialog, Button
  },
  data() {
    return {
      user: {
        id: null,
        name: '',
        email: '',
        role_id: '',
        outlet_id: '',
        phone: '',
        username: '',
        address: '',
        password: '',
        confirmation: '',
      },
      isEdit: false,
      originalPassword: '',
      validation: {
        name: {
          valid: true,
          message: ''
        },
        email: {
          valid: true,
          message: ''
        },
        phone: {
          valid: true,
          message: ''
        },
        role_id: {
          valid: true,
          message: ''
        },
        address: {
          valid: true,
          message: ''
        },
        username: {
          valid: true,
          message: ''
        },
        password: {
          valid: true,
          message: ''
        },
        confirmation: {
          valid: true,
          message: ''
        }
      },
      field: ['name', 'email', 'phone', 'role_id', 'address', 'username', 'password', 'confirmation'],
      showErrorDialog: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters('roles', ['allRoles'])
  },
  methods: {
    ...mapActions('users', ['createUser', 'updateUser', 'fetchUserById']),
    async submitUser() {
      if (this.user.password !== this.user.confirmation) {
        this.showErrorDialog = true;
        this.errorMessage = 'Konfirmasi password tidak sesuai!';
        this.validation.confirmation.valid = false;
        this.validation.confirmation.message = 'Konfirmasi password tidak sesuai!';
        return;
      }

      try {
        const userData = {
          id: this.id,
          name: this.user.name,
          role_id: this.user.role_id,
          phone: this.user.phone,
          address: this.user.address,
        }
        if (this.user.password && this.user.confirmation) {
          const token = localStorage.getItem('auth_token');
          userData.password = this.user.password;
          userData.confirmation = this.user.confirmation;
          userData.token = token;
        }

        if (this.isEdit) {
          await this.updateUser(userData);
        } else {
          userData.password = this.user.password;
          userData.email = this.user.email;
          await this.createUser(userData);
        }
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Data user berhasil disimpan!', life: 5000 });
        this.$router.push('/user');
      }
      catch (error) {
        console.error('Failed to update user', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },
  },
  async created() {
    this.$store.dispatch('roles/fetchRoles');

    const userId = this.id;
    if (userId) {
      this.isEdit = true;

      try {
        const response = await this.fetchUserById(userId);
        const userData = response.data;

        this.user = {
          id: userData.id,
          name: userData.name,
          username: userData.username,
          email: userData.email,
          role_id: userData.role_id,
          phone: userData.phone,
          address: userData.address,
        };
        this.originalPassword = userData.password;
      }
      catch (error) {
        console.error('Failed to fetch user', error);
      }
    }
  }
}
</script>